import { isEmpty } from 'lodash'

import { TEditAccountFormValues } from 'types/accounts'

export const setEditAccountRoleAssignments = (
  value: { name: string; uuid: string },
  values: TEditAccountFormValues,
  venueUuid: string,
  setFieldValue: (
    field: string,
    value: { userRoleId: string; venueId: string }[],
    shouldValidate?: boolean
  ) => void
) => {
  // if is add account form we have structure of roleAssignments: {userRoleId, venueId}, but when it is
  // edit account form we have structure of roleAsignments as initial roleAssignments or {userRoleId, venueId} if we have to create new one

  // changed roleAssignment, if is empty we should create new role assignment
  const touchedRoleAssignment = values?.roleAssignments?.filter(
    (roleAssignment) => roleAssignment.venueId === venueUuid
  )

  if (isEmpty(touchedRoleAssignment)) {
    const roleAssignmentsVenuUuids = values?.roleAssignments?.map(({ venueId }) => venueId)

    // Check which role assignment assigned to venue is marked
    if (roleAssignmentsVenuUuids.includes(venueUuid)) {
      const removedUnmarkedRoleAssignments = values?.roleAssignments?.filter(
        ({ venueId }) => venueId !== venueUuid
      )

      setFieldValue('roleAssignments', [
        ...removedUnmarkedRoleAssignments,
        { userRoleId: value.uuid, venueId: venueUuid },
      ])
    } else {
      setFieldValue('roleAssignments', [
        ...values.roleAssignments,
        { userRoleId: value.uuid, venueId: venueUuid },
      ])
    }
  } else {
    // chosen role id
    const changedRoleId = value.uuid

    const roleAssignmentWithChagnedUserRoleId = {
      ...touchedRoleAssignment[0],
      userRoleId: changedRoleId,
    }

    // remove out dated role assignment
    const roleAssignmentsWithoutOld = values?.roleAssignments?.filter(
      (roleAssignment) => roleAssignment.uuid !== roleAssignmentWithChagnedUserRoleId.uuid
    )

    setFieldValue('roleAssignments', [
      ...roleAssignmentsWithoutOld,
      roleAssignmentWithChagnedUserRoleId,
    ])
  }
}
